var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmailIcon = function SvgEmailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "nonzero",
    d: "M.968.408v22.368h32V.408h-32Zm28.288 1.76L16.968 13.72 4.68 2.168zm1.984 1.6v17.248H2.696V2.936l14.272 13.216L31.24 2.936z"
  })));
};
export default SvgEmailIcon;